export const TASK_TYPE_OPTIONS = [
    'Cleaning',
    'Maintenance',
    'Inspection',
    'Mid-stay',
    'Sanitation',
    'Check-in',
    'Inventory',
    'Administration',
    'Issue',
    'Guest Experience',
    'Finance',
    'Revenue',
];
